
import { Component } from 'react';
import { connect } from 'react-redux';
import CreateContactComponent from '../../../../components/CreateContact/CreateContact';

interface Props {
    // REDUX
    product_types?: any
}
interface State {
    name: string,
    contacts: Array<any>,

    message: string,
    messageType: string

    loading: boolean
}

const _default = {
    name: '',
    contacts: []
}

class CreateITContacts extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            ..._default,

            loading: false,
            message: '',
            messageType: 'info'
        }
    }
    render() {
        return (
            <>
                <div className="panel panel-big">

                    <h1 className="title-1">Create new contact</h1>
                    <br />
                    <CreateContactComponent />
                </div>
            </>
        );
    }

};


export default connect((state: any) => {
    return {
    }
})(CreateITContacts);
